import React, { useCallback, useContext, useEffect, useState } from "react";
import styled from "styled-components";
import TextField from "../Common/TextField";
import womanDoctor from "../../SVGs/womanDoctor.svg";
import CustomButton from "../Common/CustomButton";
import { useNavigate } from "react-router-dom";
import {
  getApiClient,
  makeStandardApiErrorHandler,
} from "../../server/get_api_client";
import { useParams } from "react-router-dom";
import RequireLogout from "../../permissions.js/RequireLogout";
import Footer from "../Common/Footer";
import Nav from "../Common/Nav";
import toast from "react-hot-toast";
import PageLoader from "../Common/PageLoader";

function Invitation() {
  const navigate = useNavigate();
  const { id } = useParams();
  const [invitationCode, setInvitationCode] = useState(id ? id : "");
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const Submit = useCallback(() => {
    if (invitationCode) {
      setIsLoading(true);
      getApiClient()
        .InvitationCode(invitationCode)
        .then((res) => {
          if (res) {
            navigate("/SetupProfile", {
              state: {
                source: 1,
                code: invitationCode,
                contactId: res.data.contactid,
              },
            });
          }
        })
        .catch(makeStandardApiErrorHandler((error) => {
          setIsLoading(false);
          toast.error("Invitation code is invalid")
        }))
    } else {
      setError("Invitaion Code Field is Required");
      setIsLoading(false);
    }
  }, [invitationCode, navigate]);

  // useEffect(() => {
  //   if (id) {
  //     setIsLoading(true);
  //     getApiClient()
  //       .InvitationCode(invitationCode)
  //       .then((res) => {
  //         if (res) {
  //           navigate("/SetupProfile", {
  //             state: {
  //               source: 1,
  //               code: invitationCode,
  //               contactId: res.data.contactid,
  //             },
  //           });
  //         }
  //       })
  //       .catch(
  //         makeStandardApiErrorHandler((error) => {
  //           toast.error("Invitation code is invalid");
  //           console.log(error);
  //         })
  //       );
  //   } else {
  //     setError("Invitaion Code Field is Required");
  //   }
  //   setIsLoading(false);
  // }, [id]);

  return (
    <>
      <PageLoader isLoading={isLoading} />
      <Nav />
      <Container>
        <InnerContainer>
        
          <LeftContaienr>
            <LeftContaienrBanner><Title>SIGN UP</Title></LeftContaienrBanner>
            <LeftContaienrContent>
            <Text>To continue your registration process, please fill in your invitation code</Text>
            {/* <Error>{error}</Error> */}
            <FieldsContainer>
              <TextField
                title={"*Invitation code:"}
                direction={"column"}
                type={"text"}
                value={invitationCode}
                setValue={setInvitationCode}
              />
            </FieldsContainer>
            <ButtonContainer>
              <CustomButton handle={Submit} title="SUBMIT" />
            </ButtonContainer>
            </LeftContaienrContent>
          </LeftContaienr>
        </InnerContainer>
      </Container>
      <Footer />
    </>
  );
}

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 95vh;
`;

const InnerContainer = styled.div`
  padding: 100px 100px;
  min-height: 85vh;
  width: 90vw;
  border-radius: 30px;
  background-image: url(${womanDoctor});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  background-attachment: local;
  padding: 7%;
  
  @media screen and (max-width: 662px) {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
  }
`;

const LeftContaienr = styled.div`
  display: flex;
  flex-direction: column;
  width: 30vw;
  min-width: 300px;
    border-radius: 20px;
  gap: 2vh;
  border-radius: 20px;
  background: #ecf3fb;
  

`;
const LeftContaienrBanner = styled.div`
display:flex;
width:auto;
background-color:#304961;
min-height:2vh;
padding:8%;
border-radius: 20px 20px 0 0;
align-items: center;
justify-content: center;
  box-shadow:0px 0px 10px #304961;


`;
const LeftContaienrContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-around;
  flex-direction: column;
  width: auto;
  gap: 2vh;
  background: #ecf3fb;
  padding:2%;
  border-radius:20px;

  @media screen and (max-width: 662px) {
    gap: 20px;
    padding: 20px 10px;
  }
`;

const Title = styled.p`
  margin-bottom: 20px;
  color: var(--white);
font-family: 'Georgia';
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: 90%;
  letter-spacing: 1px;
  white-space: wrap;
  text-transform: uppercase;


`;


const Text = styled.p`
  width: 80%;
  color: var(--darkBlue);

  font-family: "Museo Sans Cyrl";
  font-size: 20px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px; /* 120% */
`;

const FieldsContainer = styled.div`
  display: flex;
  align-items: flex-end;
  flex-direction: column;
  justify-content: center;
  gap: 10px;
`;

const ButtonContainer = styled.div`
  display: flex;
  gap: 10px;
`;

const Error = styled.div`
  color: #b20000;
  text-align: left;
  width: 80%;
  font-family: "Museo Sans Cyrl";
  font-size: 12px;
  font-style: italic;
  font-weight: 300;
`;

const FixedDimmer = styled.div`
  display: ${(props) => (props.active ? "block" : "none")};
  position: fixed !important;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 999;
  background: rgba(135, 169, 191, 0.42);
  backdrop-filter: blur(2px);
`;
export default RequireLogout(Invitation);
